(function() {
  angular.module('common')
  .factory('States', ['$resource', function($resource) {
    return $resource('states',{}, {
      query: {method: 'GET', isArray: true, cache: true}
    });
  }]);
})();
